module.exports = __webpack_public_path__ + "static/media/dice-d4.57c70fa2.svg";